import React, { useCallback, useState } from 'react';
import { OrderSummary } from '../../hooks/useOrderSummary';
import { useApplePayButton, ApplePayButton } from '../ApplePay';

type Props = {
  size?: 'small' | 'large';
  order: OrderSummary;
};

export const OrderDetailsApplePayButton: React.FC<Props> = ({ order, size }) => {
  const { getApplePayOrderSession } = useApplePayButton();
  const [session, setSession] = useState<ApplePaySession | null>(null);

  const onClick = useCallback(() => {
    const { version, request } = getApplePayOrderSession(order);

    if (request) {
      setSession(new ApplePaySession(version, request));
    }
  }, [getApplePayOrderSession, order]);

  return <ApplePayButton session={session} size={size} onClick={onClick} />;
};
